import get from 'lodash/get';

import { AppRootState } from '../../../../../store/models/app-state.model';
import { MANDANTS } from '../../../../../store/utils/files-names';
import { MandantModel } from '../../../../mandant/models/mandant.model';

export const getMandantsSelector = (
  state: AppRootState
): MandantModel[] | null => get(state, MANDANTS).mandantsArr;
